import loadjs from "loadjs";
import config from "config";
import { IAPIState } from "shared/types";
import { loggerService } from "shared/services";

export class ReCaptchaService {
  callback: (token: string) => void;
  errorCallback: () => void;
  containerId: string;

  tokenState: IAPIState = IAPIState.idle;

  constructor(callback: (token: string) => void, errorCallback: () => void, containerId: string) {
    this.callback = callback;
    this.errorCallback = errorCallback;
    this.containerId = containerId;
  }

  load = (): Promise<void> =>
    new Promise<void>(async resolve => {
      switch (this.tokenState) {
        case IAPIState.succeeded:
          return resolve();
        case IAPIState.pending:
          await new Promise(r => {
            setTimeout(r, 50);
          });
          return this.load();
        default:
          this.tokenState = IAPIState.pending;
          loadjs("https://www.google.com/recaptcha/api.js", {
            success: () => {
              this.tokenState = IAPIState.succeeded;

              grecaptcha.ready(() => {
                grecaptcha.render(this.containerId, {
                  sitekey: config.reCaptcha.sitekey,
                  size: "invisible",
                  callback: (token: string) => this.callback(token),
                  "error-callback": this.errorCallback,
                });

                return resolve();
              });
            },
            error: () => {
              this.errorCallback();
              this.tokenState = IAPIState.failed;
            },
          });
          return;
      }
    });

  ready = async () => new Promise(r => grecaptcha.ready(r));

  execute = async () => {
    try {
      await this.load();
      await this.ready();

      await grecaptcha.execute();
    } catch (error) {
      loggerService.log({
        title: "ReCaptcha",
        body: error,
      });
      this.errorCallback();
    }
  };
}
